import { render } from "./PaginationRestyle.vue?vue&type=template&id=018dc243&scoped=true"
import script from "./PaginationRestyle.vue?vue&type=script&lang=js"
export * from "./PaginationRestyle.vue?vue&type=script&lang=js"

import "./PaginationRestyle.vue?vue&type=style&index=0&id=018dc243&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-018dc243"]])

export default __exports__